/**
 * Convert Axios/Error/unknown values into a JSON-serializable object for Redux actions (serializableCheck / persist).
 */
export function serializeForReduxDetails(raw: unknown): Record<string, unknown> | undefined {
	if (raw === undefined || raw === null) return undefined;
	if (typeof raw === 'string' || typeof raw === 'number' || typeof raw === 'boolean') {
		return { message: String(raw) };
	}
	if (typeof raw !== 'object') return { message: String(raw) };

	const anyErr = raw as Record<string, unknown> & {
		message?: string;
		code?: string;
		name?: string;
		response?: { status?: number; data?: unknown };
		isAxiosError?: boolean;
	};

	if (anyErr.isAxiosError || anyErr.name === 'AxiosError' || anyErr.response != null) {
		const out: Record<string, unknown> = {
			message: typeof anyErr.message === 'string' ? anyErr.message : 'Request failed',
		};
		if (typeof anyErr.code === 'string') out.code = anyErr.code;
		const st = anyErr.response?.status;
		if (typeof st === 'number') out.httpStatus = st;
		const d = anyErr.response?.data;
		if (d !== undefined) {
			try {
				JSON.stringify(d);
				out.responseData = d;
			} catch {
				out.responseData =
					typeof d === 'string' ? d : '[non-serializable response body]';
			}
		}
		return out;
	}

	if (raw instanceof Error) {
		return { message: raw.message, name: raw.name };
	}

	try {
		JSON.parse(JSON.stringify(raw));
		return raw as Record<string, unknown>;
	} catch {
		return { message: '[Unserializable details]' };
	}
}
